import $ from 'jquery';

export default () => {
  $(".resource-list, .selected-resources").on("click", ".resource-container .play-video-btn", function(e) {
    e.preventDefault();

    const clicked = $(this);
    const videoContainer = clicked.siblings("iframe").first();

    clicked.hide();
    videoContainer.attr("src", videoContainer.attr("data-src"));
  });
};